/**
 * Joins two arrays.
 * @param {Array} array1 - Array to be joined.
 * @param {Array} array2 - Array to be joined.
 * @returns {Array} A new Array object, representing the joined array.
 */
export default function immutableConcat(array1, array2) {
  return [...array1, ...array2];
}
